import axios from 'axios'
import { createLogic, createLogicMiddleware } from 'redux-logic'

import { saveTokenDetails } from '../actions/login'
import { getPortalGetAccount } from '../api/env'
import { logger } from './../lib/utils/logger'


const checkWhitelabel = async ({ token }) => {
  try {
    const { data: { whitelabel: { url = null, square: ondemand } = {} } } = await axios.get(
      getPortalGetAccount(),
      {
        headers: {
          'Authorization': `Netop ${token}`
        }
      })
    if (url && ondemand) {
      logger('--whitelabel', { url, square: ondemand })
      // eslint-disable-next-line
      $('head').append(`<style>.sideBar .topLogo { background-image: url('${url}/${ondemand}?ts=${Date.now()}');}</style>`)
    }
  } catch (error) {
    console.log('error') // eslint-disable-line
  }
}

export const whitelabelLogic = createLogic({
  type: [saveTokenDetails],

  process ({ getState }, dispatch, done) {
    const { login: { token = null } = {} } = getState()
    if (token) {
      checkWhitelabel({ token })
        .then(() => done())
    } else {
      done()
    }
  }
})

const arrLogic = [whitelabelLogic]

export const whitelabelLogicMiddleware = createLogicMiddleware(arrLogic)
